'use strict';

module.exports = {
    ELEMENT: {
        CLICK: 'click',
        HOVER: 'hover'
    },

    WINDOW: {
        SCROLL: 'scroll'
    },
    FORM: {
        SUBMIT: 'submit'
    },

    CUSTOM: {
        SANDWICH: {
            OPENED: 'sandwich-opened',
            CLOSED: 'sandwich-closed'
        },
        POPUP_MENU: {
            CLOSED: 'popup-menu-closed'
        },
        PHONE_POPUP: {
            OPENED: 'phone-popup-opened',
            CLOSED: 'phone-popup-closed'
        },
        LOGIN_POPUP: {
            OPENED: 'login-popup-opened',
            CLOSED: 'login-popup-closed'
        }
    }
};